import { SVGProps } from 'react';

const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <circle cx={12} cy={12} r={10} stroke="#292929" strokeWidth={2} />
    <path stroke="#292929" strokeLinecap="round" strokeWidth={2} d="M12 7v6" />
    <circle cx={12} cy={16} r={1} fill="#292929" />
  </svg>
);

export default SvgWarning;
